import { render } from "./UserManagmentComponent.vue?vue&type=template&id=9577702e"
import script from "./UserManagmentComponent.vue?vue&type=script&lang=js"
export * from "./UserManagmentComponent.vue?vue&type=script&lang=js"

import "./UserManagmentComponent.vue?vue&type=style&index=0&id=9577702e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__